import axiosInstance from "../axiosInstance";

export const catalogPlanNoteService = {
  fetchByPlan: async (planId) => {
    try {
      const response = await axiosInstance.get(
        `/catalog-plan-note?plan_id=${planId}&$sort[createdAt]=-1&$limit=100`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchByCategory: async (planId, categoryId) => {
    try {
      const response = await axiosInstance.get(
        `/catalog-plan-note?plan_id=${planId}&category_id=${categoryId}&$sort[createdAt]=-1&$limit=100`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await axiosInstance.post("/catalog-plan-note", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await axiosInstance.patch(
        `/catalog-plan-note/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/catalog-plan-note/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
